// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#phone[data-v-7e7f014b] {\n  padding-left: 64px;\n}\n", ""]);
// Exports
module.exports = exports;
